module.exports = __webpack_public_path__ + "packs/media/images/crowdfunding/falesia1_thumb-2ff427216530e4521402efacd7cace0c.jpg";